<template>
  <v-container fluid>
    <div class="tables-basic">
      <br />
      <h1 class="page-title mt-16 mb-6">Departamentos</h1>
      <v-row>
        <v-col cols="12">
          <v-card class="employee-list mb-1">
            <v-card-title class="pa-6 pb-3">
              <v-row>
                <v-dialog v-model="dialogNuevoDepartamento" persistent max-width="600px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      color="primary"
                      small
                      dark
                      v-if="$store.state.usuario.rol !== 'lectura_mtto'"
                      >Nuevo Departamento</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete
                              :items="empresas"
                              v-on:change="filterEmpresa()"
                              v-model="empresa"
                              label="Empresas"
                            ></v-autocomplete>
                            <div v-if="submited && !$v.empresa.required">
                              <v-alert
                                dense
                                v-model="alert"
                                dismissible
                                color="red"
                                border="left"
                                elevation="2"
                                colored-border
                                icon="mdi-alert-octagon"
                              >
                                <strong>Error</strong> Campo Empresa es requerido
                              </v-alert>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="departamento"
                              label="Departamento"
                            ></v-text-field>
                            <div v-if="submited && !$v.departamento.required">
                              <v-alert
                                dense
                                v-model="alert"
                                dismissible
                                color="red"
                                border="left"
                                elevation="2"
                                colored-border
                                icon="mdi-alert-octagon"
                              >
                                <strong>Error</strong> Campo Departamento es requerido
                              </v-alert>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              :items="ubicaciones"
                              v-model="ubicacion"
                              label="Ubicaciones"
                            ></v-autocomplete>
                            <div v-if="submited && !$v.ubicacion.required">
                              <v-alert
                                dense
                                v-model="alert"
                                dismissible
                                color="red"
                                border="left"
                                elevation="2"
                                colored-border
                                icon="mdi-alert-octagon"
                              >
                                <strong>Error</strong> Campo Ubicacion es requerido
                              </v-alert>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="cerrarModalDepartamento()"
                      >
                        Cerrar
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="guardar()">
                        Guardar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                clearable
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              dense
              :headers="headers"
              :items="departamentos"
              :search="search"
            >
              <template
                v-if="$store.state.usuario.rol !== 'lectura_mtto'"
                v-slot:[`item.action`]="{ item }"
              >
                <v-icon @click="editItem(item)" small class="mr-2"
                  >mdi-border-color</v-icon
                >
                <template>
                  <v-icon class="mr-2">mdi-delete</v-icon>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import Catalogo from "../../api/Catalogo";
export default {
  validations: {
    empresa: {
      required,
    },

    departamento: {
      required,
    },
    ubicacion: {
      required,
    },
  },
  data() {
    return {
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Empresa", value: "empresa.razonSocial", sortable: true },
        {
          text: "Nombre Comercial",
          value: "empresa.nombreComercial",
          sortable: true,
        },
        { text: "Departamento", value: "departamento", sortable: true },
        { text: "Ubicacion", value: "ubicacion.ubicacion", sortable: true },
      ],
      departamentos: [],
      departamento: "",
      empresas: [],
      empresa: "",
      ubicacion: "",
      direccion: "",
      search: "",
      dialogNuevoDepartamento: false,
      ubicaciones: [],
      empresaSeleccionada: "",
      editedIndex: -1,
      submited: "",
      alert: "",
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Departamento" : "Editar Departamento";
    },
  },
  created() {
    this.listar();
    this.selectEmpresas();
  },
  methods: {
    listar() {
      let me = this;
      let empresaUsuario = this.$store.state.usuario.personal.empresa;
      let usuario = this.$store.state.usuario.rol;
      this.departamentos = [];
      Catalogo.obtenerDepartamentos()
        .then((res) => {
          if (usuario == "capturista") {
            res.data.forEach((e) => {
              if (e.empresa._id == empresaUsuario) {
                me.departamentos.push(e);
              }
            });
            me.empresas.push({
              text: me.departamentos[0].empresa.nombreComercial,
              value: me.departamentos[0].empresa._id,
            });
          } else {
            me.departamentos = res.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    limpiar() {
      (this.empresa = ""), (this.departamento = ""), (this.ubicacion = "");
      this.alert = false;
    },
    guardar() {
      let me = this;
      if (this.editedIndex > -1) {
        axios
          .put("/departamentos/update", {
            _id: this._id,
            empresa: this.empresa,
            departamento: this.departamento,
            ubicacion: this.ubicacion,
          })
          .then(function (response) {
            console.log(response);
            me.listar();
            me.dialogNuevoDepartamento = false;
            me.addSuccessNotification("Departamento actualizado");
            me.limpiar();
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.submited = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          me.alert = true;
          me.addErrorNotification();
          return false;
        }
        axios
          .post("/departamentos/add", {
            empresa: this.empresa,
            departamento: this.departamento,
            ubicacion: this.ubicacion,
          })
          .then(function (response) {
            console.log(response);
            me.listar();
            me.dialogNuevoDepartamento = false;
            me.addSuccessNotification("Departamento agregada");
            me.limpiar();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    editItem(item) {
      this._id = item._id;
      this.empresa = item.empresa._id;
      this.ubicacion = item.ubicacion._id;
      this.departamento = item.departamento;
      this.editedIndex = 1;
      this.selectUbicaciones(item.empresa._id);
      this.dialogNuevoDepartamento = true;
    },
    selectEmpresas() {
      let me = this;
      let empresaArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if (this.$store.state.usuario.rol !== "capturista") {
        axios
          .get("/empresa/list", configuracion)
          .then((response) => {
            empresaArray = response.data;
            empresaArray.map(function (x) {
              me.empresas.push({ text: x.nombreComercial, value: x._id });
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    filterEmpresa() {
      this.ubicaciones = [];
      this.empresaSeleccionada = this.empresa;
      this.selectUbicaciones(this.empresaSeleccionada);
    },

    selectUbicaciones(empresa) {
      let me = this;
      let departamentoArrya = [];
      axios
        .get("/ubicacion/queryEmpresa?empresa=" + empresa)
        .then((response) => {
          departamentoArrya = response.data;
          departamentoArrya.map(function (x) {
            me.ubicaciones.push({ text: x.ubicacion, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addSuccessNotification(mensaje) {
      this.$toast.success(mensaje, {
        position: "top-right",
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
      });
    },
    addErrorNotification() {
      this.$toast.error("Error, verifique los campos ingresados", {
        position: "top-right",
        timeout: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: true,
      });
    },
    cerrarModalDepartamento() {
      this.dialogNuevoDepartamento = false;
      this.limpiar();
      this.editedIndex = -1;
    },
  },
};
</script>
